import { RewardTokenType } from '../../../../lib/tokens-base/token-base.models';

export function getTokenTrackingType(rewardTokenType: RewardTokenType, customTitle: string = ''): string {
    const titleSuffix = customTitle ? ': ' + customTitle : '';
    switch (rewardTokenType) {
        case RewardTokenType.FreeBet:
            return 'freebet';
        case RewardTokenType.OddsBoost:
            return 'oddsboost';
        case RewardTokenType.RiskFreeBet:
            return 'riskfree';
        case RewardTokenType.BetStationFreebet:
            return 'betstation-freebet';
        case RewardTokenType.AccaBoost:
            return 'accaboost';
        case RewardTokenType.BetAndGet:
            return 'bet & get' + titleSuffix;
    }

    throw new Error('Invalid token!');
}
